export const POST_NEWUSER_SUCCESS = "success/POST_NEWUSER_SUCCESS";
export const POST_NEWUSER_FAILURE = "success/POST_NEWUSER_FAILURE";
export const GET_ALL_NEWUSER_SUCCESS = "success/GET_ALL_NEWUSER_SUCCESS";
export const GET_ALL_NEWUSER_FAILURE = "success/GET_ALL_NEWUSER_FAILURE";
export const GET_SINGLE_NEWUSER_SUCCESS = "success/GET_SINGLE_NEWUSER_SUCCESS";
export const GET_SINGLE_NEWUSER_FAILURE = "success/GET_SINGLE_NEWUSER_FAILURE";
export const REMOVE_NEWUSER_SUCCESS = "success/REMOVE_NEWUSER_SUCCESS";
export const REMOVE_NEWUSER_FAILURE = "success/REMOVE_NEWUSER_FAILURE";
export const UPDATE_NEWUSER_SUCCESS = "success/UPDATE_NEWUSER_SUCCESS";
export const UPDATE_NEWUSER_FAILURE = "success/UPDATE_NEWUSER_FAILURE";
export const ALL_USERS_SUCCESS = "success/ALL_USERS_SUCCESS";
export const ALL_USERS_FAILURE = "success/ALL_USERS_FAILURE";